/**
 * Status Hover Component
 * Handles hover interactions between status articles and bubble cloud
 *
 * @package oska
 */

export default function initStatusHover() {
  const articles = document.querySelectorAll("[data-status-slug]");
  const bubbleCloud = document.querySelector("[data-bubble-cloud]");

  if (!articles.length || !bubbleCloud || !bubbleCloud._bubbleCloud) {
    return;
  }

  const instance = bubbleCloud._bubbleCloud;

  articles.forEach((article) => {
    const color = article.dataset.statusColor;

    article.addEventListener("mouseenter", () => {
      // Dim other articles
      articles.forEach((a) => {
        if (a !== article) {
          a.style.opacity = "0.5";
        }
      });
      // Highlight matching color in bubble cloud
      instance.setHighlight(color);
    });

    article.addEventListener("mouseleave", () => {
      // Reset articles
      articles.forEach((a) => {
        a.style.opacity = "";
      });
      // Clear highlight
      instance.setHighlight(null);
    });
  });
}
